export const RiskScoreQueryKeys = {
  lists: 'risk-scores',
  metricGroups: 'risk-metric-group',
  exports: 'risk-scores-export',
  metricGroupExports: 'risk-metric-group-export',
  filterOptions: 'risk-scores-filter-options',
} as const;
